export const isAdaptiveVideo = (videoUrl) => !!videoUrl?.includes(".m3u8");
